<app-column-title [column]="column"></app-column-title>

@if (column.mapWith) {
  <div class="column-value">
    {{ column.mapWith + getData | cxTranslate }}
  </div>
} @else {
  <div class="column-value" [id]="column.finalKey">
    {{ getData }}
  </div>
}
